
import { GTMEvent } from './types/gtm';
import { DEFAULT_DATA_LAYER_NAME } from './constants';

export const isServer = typeof window === 'undefined';
export const isBrowser = !isServer;

if (isBrowser) {
  window[DEFAULT_DATA_LAYER_NAME] = window[DEFAULT_DATA_LAYER_NAME] ?? [];
}

export const sendGTMEvent = <T extends object>(data: GTMEvent<T>) => {
  const dataLayer = window[DEFAULT_DATA_LAYER_NAME as keyof Window];

  dataLayer.push(data);

  if ('ecommerce' in data) {
    dataLayer.push({ ecommerce: null });
  }
};
